
<template>
  <div class="figure" v-if="name">
    <img :class="[appearance]" :src="`/figures/${this.name}`" :alt="alt" />
    <p class="figure-desc" v-if="desc">{{ desc }}</p>
  </div>
</template>

<script>
export default {
  name: "Figure",
  data() {
    return {
      alt: "",
    };
  },
  props: ["name", "desc", "appearance"],
  computed: {},
  methods: {},
  mounted() {
    this.alt = this.desc || "";
  },
};
</script>

<style>
p + .figure {
  margin-top: 5rem;
}

.figure + p {
  margin-top: 5rem;
}

.figure {
  width: 100%;
  height: auto;
}

.figure img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.figure img.wide {
  max-width: calc(100% + 300px);
  margin-left: -150px;
}

.figure p.figure-desc {
  font-style: italic;
  width: 100%;
  text-align: center;
  opacity: 0.7;
  margin-top: 8px;
}

@media (max-width: 655px) {
  .figure img.wide {
    max-width: 100%;
    margin: 0;
  }
}
</style>
